import { NavigationGuard } from 'vue-router';
import router from '.';
import { PAGE_PATH_BY_NAME, UNDEFINED_PATH_NAME } from '@/utils/consts';

const QueryKey = 'redirect_path';

export const redirect: NavigationGuard = (to, _, next) => {
  if (to.query[QueryKey]) {
    const path = `/${to.query[QueryKey]}`.replace('/index.html', '');
    const resolvedRoute = router.resolve(path);
    if (
      !resolvedRoute.route.name ||
      resolvedRoute.route.name === UNDEFINED_PATH_NAME
    ) {
      next(PAGE_PATH_BY_NAME.portal);
    } else {
      next({ path });
    }
  } else {
    next();
  }
};
